export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/a2cdf02300b2663230f496dbfe02b4a0.svg";